export enum Backend {
	HANDOUT = "handout",
	LOGCAT = "[DEFAULT]",
}